import loaderImg from '@/assets/loader.png';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  inline?: boolean;
}

const sizes = {
  sm: 'w-5',
  md: 'w-8',
  lg: 'w-12',
};

const pageSizes = {
  sm: 'w-8',
  md: 'w-24',
  lg: 'w-36',
};

export const LoadingSpinner = ({ className, size = 'md', inline = false }: LoadingSpinnerProps) => {
  const img = (
    <img
      src={loaderImg}
      alt=""
      className={cn('animate-spin rounded-full', sizes[size], className)}
    />
  );

  if (inline) return img;

  return (
    <div className="flex items-center justify-center py-20">
      <img
        src={loaderImg}
        alt=""
        className={cn('animate-spin rounded-full', pageSizes[size], className)}
      />
    </div>
  );
};
